import { useRef, useEffect } from 'react';
import './MediaPlayerThree.css';
MediaPlayer.version = 1000;

MediaPlayer.lang = 'en';
MediaPlayer.langs = [
  'en'
];
MediaPlayer.setLang = (lang: any) => {
  MediaPlayer.lang = lang;
}
declare global {
  interface Window {
    spl: any;
  }
}
interface CustomWindow extends Window {
  player: any;
}

declare var window: CustomWindow;
interface CustomWindow extends Window {
  player: any;
  slikeLoaded: any;
  SlikePlayer: any;
}

declare var window: CustomWindow;

Object.defineProperty(MediaPlayer, 'name', {
  writable: true,
  value: 'MediaPlayer'
});





export function MediaPlayer(props: any) {
  const { slikeId, apiKey, Pl_Type, autoPlay, skipAd, mute, playInBackground } = props;
  const playerContainerRef = useRef(null);

  function LoadPlayer(slikeId: any) {

    let id_Slike  = slikeId
    //let playerType = slikeId.startsWith("YT_") ? 10 : ''
    
    //console.log('slikeId init', slikeId, containerId,id_Slike)
    let PLAYER_CONFIG: any = {
      "apiKey": apiKey,
      "contEl": `playerContainer_${slikeId}`,
      "env": "stg",
      "version": "3.8.24",
      "debug": false,
      "video": {
        "id": `${id_Slike}`,
        //"playerType":`${playerType}`
      },
      "controls": {
        "dock": {
          "type": "custom",
          "dismissible": true,
          "height": "219px",
          "width": "390px",
          "position": "bottom-right"
        }
      },
      "player": {
        "autoPlay": autoPlay,
        "fallbackMute": true,
        "mute": mute,
        "skipAd": skipAd,
        "volume": 70,
        "skipAnalytics":true,
        "scrollBehaviour": {
          "inViewPercent": 80,
          "dock": props.Pl_Type === 'Audio' ? false : true,
          "autoPlay": true
        },
        "playInBackground": playInBackground

      }
    }
   
    
    if (props.Pl_Type === 'Audio') {
      PLAYER_CONFIG.controls.ui = "podcast";
    }
    
    if (window.spl && window.spl.load && !window.slikeLoaded) {
      window.spl.load(PLAYER_CONFIG, function (status: any, config: any) { 
        if (status) {
          ////console.log("slike loaded")
          window.slikeLoaded = true;
          if(!window.player){
            window.player = {}
          }
          window.player[slikeId] = new window.SlikePlayer(PLAYER_CONFIG);
          //window.player = new window.SlikePlayer(PLAYER_CONFIG);
        }

      });
    }else{
      const intervalId = setInterval(() => {
if(window.SlikePlayer){
  window.player[slikeId] = new window.SlikePlayer(PLAYER_CONFIG);
  clearInterval(intervalId);
}
      }, 2000)
      
    }

    
  }

  useEffect(() => {
    // Load scripts only on the client side
    if (playerContainerRef.current) {
    ////console.log('slikeid usefeect',slikeId,playerContainerRef.current)
    LoadPlayer(slikeId);
    }
  }, []);
  return (
      <div id={`playerContainer_${slikeId}`} ref={playerContainerRef} className={Pl_Type === 'Audio' ? 'playerContainerAudioSingle __sast' : 'playerContainer'}></div>
  );
}
